module.exports = __webpack_public_path__ + "static/logo-group-2x-2b1c592208c034bf40ef395f14bdb916.png";